import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

const SkillChip = ({ skill, onRemove, disabled = false }) => {
  const label = skill?.skill_name || skill?.name || '';

  return (
    <motion.span
      layout
      initial={{ opacity: 0, scale: 0.92 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.92 }}
      whileHover={{ y: -2, scale: 1.02 }}
      className="group inline-flex max-w-full items-center gap-2 rounded-full border border-purple-300/30 bg-purple-500/15 px-3 py-2 text-sm font-semibold text-purple-50 shadow-lg shadow-purple-950/20 backdrop-blur transition hover:border-pink-300/60 hover:bg-pink-500/15 hover:shadow-pink-500/20"
    >
      <span className="truncate">{label}</span>
      <button
        type="button"
        onClick={() => onRemove(skill)}
        disabled={disabled}
        aria-label={`Remove ${label}`}
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/10 text-purple-100 transition hover:bg-pink-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </motion.span>
  );
};

export default SkillChip;

